<script setup lang="ts">
import { mdiClose } from "@mdi/js";
import SwipeBet from "./SwipeBet.vue";

const route = useRoute();
const router = useRouter();

const isOpen = computed(() => {
	return route.query.swipebet === "true" || route.query.swipebet === "1" || route.query.swipeBet === "true";
});

const closeModal = () => {
	const { swipebet, ...newQuery } = route.query;

	router.push({
		path: route.path,
		query: newQuery,
	});
};

const handleKeydown = (event: KeyboardEvent) => {
	if (event.key === "Escape" && isOpen.value) {
		closeModal();
	}
};

onMounted(() => {
	document.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
	document.removeEventListener("keydown", handleKeydown);
	document.body.style.overflow = "";
});

watch(isOpen, (newValue) => {
	if (newValue) {
		document.body.style.overflow = "hidden";
	} else {
		document.body.style.overflow = "";
	}
});
</script>

<template>
	<Teleport to="body">
		<Transition
			enter-active-class="transition-opacity duration-300 ease-out"
			enter-from-class="opacity-0"
			enter-to-class="opacity-100"
			leave-active-class="transition-opacity duration-200 ease-in"
			leave-from-class="opacity-100"
			leave-to-class="opacity-0"
		>
			<div v-if="isOpen" class="fixed inset-0 z-50 bg-dark-900/20 backdrop-blur-sm" @click.self="closeModal">
				<div class="flex flex-col items-center justify-center h-full">
					<div class="flex flex-col items-center justify-center">
						<div class="flex flex-row items-end justify-end w-full">
							<div
								@click="closeModal"
								class="z-50 p-2 mb-2 transition-all duration-200 rounded-lg shadow-md cursor-pointer hover:shadow-2xl dark:bg-dark-700 group hover:bg-primary-50 dark:hover:bg-[#003a00] bg-light-50 bg-black/30 backdrop-blur-sm"
								aria-label="Close SwipeBet"
							>
								<UiIcon :path="mdiClose" class="w-5 h-5 transition-all duration-200 dark:fill-light-50 fill-white group-hover:scale-110" />
							</div>
						</div>
						<div class="px-4 pb-2 rounded-xl bg-light-200 dark:bg-dark-900">
							<SwipeBet />
						</div>
					</div>
				</div>
			</div>
		</Transition>
	</Teleport>
</template>
